import * as React from "react";
import { Box, Chip } from "@mui/material";
import { H2, H4, H5 } from "components/CustomTypography";
import ButtonComponent from "components/Button";
import { getPriceCurrency } from "helpers/utils";

import "./style.scss";

const TryOnPackageCard = (props) => {
  const { currency, data, onSelect } = props;

  const { 
    title, 
    description, 
    credits, 
    price, 
    original_price,
    discount_percentage,
    badge,
    features = []
  } = data || {};

  return (
      <>
    <Box display="flex" className="styled-card">

      <Box width="70%" >
        <Box width="100%">
        <H2 fontSize={20} ellipsis>
          {title}
        </H2>
        <H4 fontSize={14} color="text.secondary">
          {description}
        </H4>
        </Box>
      </Box>
      <Box width="30%" >
        <ButtonComponent
            type="primary"
            variant="contained"
            name="Buy Now"
            size="large"
            fullWidth
            onClick={() => onSelect(data)}
        />
      </Box>
    </Box>

        <Box width="100%">

          <Box display="flex" width="100%">
            <H2 fontSize={24} color="primary" component="span">
              {credits}
            </H2>
            <H4 component="span" ml={1}>
              Credits
            </H4>

            <Box fontSize={18} mr={1}>
              {getPriceCurrency(price, currency)}
            </Box>
            {discount_percentage > 0 && (
                <>
                  <Box
                      fontSize={18}
                      color="text.secondary"
                      sx={{ textDecoration: 'line-through' }}
                  >
                    {getPriceCurrency(original_price, currency)}
                  </Box>
                  <Chip
                      label={`${discount_percentage}% OFF`}
                      color="success"
                      size="small"
                      sx={{ ml: 1 }}
                  />
                </>
            )}
          </Box>

        </Box>
  <Box width="100%">
    {features && features.length > 0 &&
        features.map((feature, index) => (
            <span>{feature}</span>
        ))
    }
  </Box>
  </>
  );
};

export default TryOnPackageCard;
